.columnLink {
    padding-bottom: 0.75rem;
    color: var(--color-emperor);
    display: block;
    text-decoration: none;
    line-height: inherit;
    cursor: pointer;
    text-transform: none;

    &:hover {
        text-decoration: underline;
    }
}
